/* -------------------------------------------------------------------------- */
/*                                  Mint Status                               */
/* -------------------------------------------------------------------------- */

export enum MintStatus {
	IN_PROGRESS = 'IN_PROGRESS',
	PENDING = 'PENDING',
	ERROR = 'ERROR',
	SUCCESS = 'SUCCESS',
	BYPASSED = 'BYPASSED',
}

export const STATUS_PERCENT_MAPPING: {
	[key: string]: string;
} = {
	[`${MintStatus.PENDING},${MintStatus.PENDING},${MintStatus.PENDING}`]:
		'20',
	[`${MintStatus.ERROR},${MintStatus.PENDING},${MintStatus.ERROR}`]:
		'40',
	[`${MintStatus.IN_PROGRESS},${MintStatus.PENDING},${MintStatus.IN_PROGRESS}`]:
		'60',
	[`${MintStatus.SUCCESS},${MintStatus.IN_PROGRESS},${MintStatus.IN_PROGRESS}`]:
		'80',
	[`${MintStatus.SUCCESS},${MintStatus.ERROR},${MintStatus.ERROR}`]:
		'80',
	[`${MintStatus.SUCCESS},${MintStatus.SUCCESS},${MintStatus.SUCCESS}`]:
		'100',
	[`${MintStatus.BYPASSED},${MintStatus.BYPASSED},${MintStatus.BYPASSED}`]:
		'100',
};

export const STATUS_MESSAGE: {
	[key: string]: string;
} = {
	[`${MintStatus.PENDING},${MintStatus.PENDING},${MintStatus.PENDING}`]:
		'mintHistories.tooltip.pinPending',
	[`${MintStatus.ERROR},${MintStatus.PENDING},${MintStatus.ERROR}`]:
		'mintHistories.tooltip.pinError',
	[`${MintStatus.IN_PROGRESS},${MintStatus.PENDING},${MintStatus.IN_PROGRESS},60`]:
		'mintHistories.tooltip.pinDataRetrieved',
	[`${MintStatus.SUCCESS},${MintStatus.IN_PROGRESS},${MintStatus.IN_PROGRESS}`]:
		'mintHistories.tooltip.mintProcessing',
	[`${MintStatus.SUCCESS},${MintStatus.ERROR},${MintStatus.ERROR}`]:
		'mintHistories.tooltip.mintError',
	[`${MintStatus.SUCCESS},${MintStatus.SUCCESS},${MintStatus.SUCCESS}`]:
		'mintHistories.tooltip.mintCompleted',
	[`${MintStatus.BYPASSED},${MintStatus.BYPASSED},${MintStatus.BYPASSED}`]:
		'mintHistories.tooltip.mintBypassed',
};

export const STATUS_LABEL: {
	[key: string]: string;
} = {
	[`${MintStatus.PENDING},${MintStatus.PENDING},${MintStatus.PENDING}`]:
		'PENDING',
	[`${MintStatus.IN_PROGRESS},${MintStatus.PENDING},${MintStatus.IN_PROGRESS}`]:
		'IN_PROGRESS',
	[`${MintStatus.ERROR},${MintStatus.PENDING},${MintStatus.ERROR}`]:
		'ERROR',
	[`${MintStatus.SUCCESS},${MintStatus.IN_PROGRESS},${MintStatus.IN_PROGRESS}`]:
		'IN_PROGRESS',
	[`${MintStatus.SUCCESS},${MintStatus.ERROR},${MintStatus.ERROR}`]:
		'ERROR',
	[`${MintStatus.SUCCESS},${MintStatus.SUCCESS},${MintStatus.SUCCESS}`]:
		'SUCCESS',
	[`${MintStatus.BYPASSED},${MintStatus.BYPASSED},${MintStatus.BYPASSED}`]:
		'BYPASSED',
};
